// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Sort: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 38 26" enableBackground="new 0 0 38 26" xmlSpace="preserve">
<g>
	<rect x="0.25" y="10.92" width="25" height="4.17"/>
	<rect x="0.25" y="21.33" width="12.5" height="4.17"/>
	<rect x="0.25" y="0.5" width="37.5" height="4.17"/>
</g>
</svg>;
};

export default React.memo(Sort);
